
import contentTemplate from 'properties/style/caption.ejs';
import BasePropertyView from 'BasePropertyView.js'

import eventBus         from 'EventBus.js';
import Immutable                from 'immutable'; 

class StyleCaptionView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        return this;
    }

    render() {
      this.$el.empty();
      const alignRightBI = Immutable.Set([
        'control_clear_filter_button',
        'control_print_button',
        'control_submit_button',
        'control_text',
        'control_small_text',
        'control_large_heading',
        'control_medium_heading',
        'control_small_heading',
        'control_button',
        'control_submit_button',
        'control_page_button',
        'control_bullet_text',
        'control_text_input',
        'control_multiple_text_input',
        'control_numeric_input',
        'control_date_input',
        'control_date_calendar',
        'control_time_input',
        'control_checkbox',
        'control_checkbox_group',
        'control_radio_button_group',
        'control_radio_button',
        'control_list',
        'control_numeric_stepper',
        'control_mask_text_input',
        'control_image_input',
        'control_vertical_slider',
        'control_horizontal_slider',
        'control_ranking',
        'control_play_form_button',
        'control_play_report_button'
      ]);
      this.model.set('alignRightBI',alignRightBI,{silent: true});
      this.$el.html(this.template(this.model.toJSON()));

      return this;
    }

}

export default StyleCaptionView;
